declare var LOADMANAGERURL: string;
declare var PLANTCODE: string;
declare var CUSTOMERID: string;
declare const HEADERCOLOR: string;
module BookByPlant {

    interface IBookByPlantScope extends IBookScope {
        removeUndefined: () => void;
        loc: any;
        next: (plantCode: string) => void;
        ParseLocation: (location: CustomerPlant) => void;
        getBookingAvail: () => void;
        showDanger: boolean;
    }

    class BookByPlantController extends LM.BookingBase<IBookByPlantScope> {
        constructor(public $scope: IBookByPlantScope, $http: ng.IHttpService, WizardHandler: any, $uibModal: any, FileUploader: any, genericHelper: LM.GenericHelperService, $window: ng.IWindowService, $timeout: ng.ITimeoutService) {
            super($scope, genericHelper, $uibModal, WizardHandler, FileUploader, $http);
            this.$scope.showDanger = false;
            $scope.loadUnload = [
                { name: 'Load', img: '../../Content/Icons/load.png' },
                { name: 'Unload', img: '../../Content/Icons/unload.png' }
            ];
            $scope.totQty = 0;
            $scope.isDisabledSelectFromExistingShipment = false;
            $scope.customerCode = CUSTOMERID;
            $scope.plantCode = PLANTCODE;
            $scope.firstTitle = '1';
            $scope.secondTitle = '2';
            if (window.location !== window.parent.location) {
                // The page is in an iframe
                (<HTMLElement>document.getElementsByClassName('navbar navbar-primary navbar-fixed-top').item(0)).style.display = 'none';
                document.body.style.paddingTop = '0px';
            } else {
                // The page is not in an iframe
            }
            $scope.emailRegex = genericHelper.emailRegex;

            var _this = this;
            $('#hamburger-icon').css('color', checkHeaderColor(HEADERCOLOR));
           
            $scope.ParseLocation = function (location: CustomerPlant) {
                let anchor = window.location.hash;
                $scope.accordionGroup.anchor = "";
                if (anchor && anchor.length == 2) {
                    if (anchor == "#b") {
                        $scope.accordionGroup.existing = true;
                        $scope.accordionGroup.fromScratch = false;
                        $scope.accordionGroup.anchor = "#b";
                    } else if (anchor == "#c") {
                        $scope.accordionGroup.existing = true;
                        $scope.accordionGroup.fromScratch = false;
                        $scope.accordionGroup.hideFromScratch = true;
                        $scope.accordionGroup.anchor = "#c";
                    }
                }
                if (location) {
                    $scope.loc = location;
                    $scope.plantId = location.Id;
                    genericHelper.$http.post<any>('/Booking/Book/GetSupportMail', { PlantId: $scope.plantId }).then(function (response) {
                        if (response.data != "" && response.data) {
                            $('#help-desk-by-plant').attr("href", "mailto:" + response.data)
                        }
                    });

                    $scope.InvitationOnly = location.InvitationOnly;
                    $http.get<WfMandatoryField[]>('/booking/book/GetMandatoryFields?PlantCode=' + $scope.loc.ExternalCode + '&CustId=' + $scope.customerCode).then(res => {
                        $scope.mandatoryFieldsList = res.data;
                    });
                    $http.get<BookingFieldLabelsGet>('/booking/book/GetBookingFieldLabels?PlantCode=' + $scope.plantCode + '&CustId=' + $scope.customerCode).then(res => {
                        $scope.bookingFieldLabels = res.data;
                    });

                    $scope.plantCode = $scope.loc.ExternalCode;
                    _this.GetD($scope.loc.Id).then(() => {
                        _this.findTimeAfterFreeze($scope.loc.Id);
                        $scope.initialDateTime = moment($scope.data.selecteddate).add($scope.data.selectedtime, "h");
                        window.parent.postMessage("Loaded", "*");

                        if (window.location.search.indexOf('prebookings=') >= 0) {
                            let tmp = window.location.search.split("prebookings=");
                            if (tmp.length > 0) {
                                $scope.findMultipleShipments(tmp[1]);
                            }
                        }
                    });
                }
            };

            $scope.allowPdfDownload = false;
            $scope.canSave = false;
            $scope.privacyStatement = '';

            $scope.hubSR = genericHelper.createSignalRHub();

            $window.addEventListener('message', (event) => {
                if (event.data != 'recaptcha-setup' && event.data != 'Loaded') {
                    const loader = $uibModal.open({
                        template: '<img src="/Content/Icons/loader.gif">',
                        backdrop: 'static',
                        windowClass: 'loader'
                    });
                    $timeout(() => {
                        console.log(`Selected date: ${moment($scope.data.selecteddate, 'YYYY/MM/DD').format()}`);
                        console.log('MEssage event: ' + moment().format());
                        $scope.isDisabledSelectFromExistingShipment = true;
                        try {
                            const p = JSON.parse(event.data);
                            console.log(`Planned check in: ${MoveFromUTCToLocal(moment(p.plannedCheckIn), this.TZ).format()}`);
                            $scope.data.refname = p.fatherShipment;
                            $scope.data.refnum = p.sonShipment;
                            $scope.data.external = p.external;
                            $scope.data.sender = p.shipmentCreator ? p.shipmentCreator.email : '';
                            $scope.data.receiver = p.receiver.name + ' ' + p.receiver.address;
                            $scope.data.selectedTruckType = p.truckType;
                            $scope.data.notes = p.notes;
                            $scope.data.truckplate = p.truckPlate;
                            $scope.data.trailerplate = p.trailerPlate;
                            // 30/11/2021 Deciso che minDate non vale come avviso ma diventa vincolo
                            //this.min = moment.utc(p.firstValidDate);
                            $scope.data.selecteddate = moment.max(moment($scope.data.selecteddate, 'YYYY/MM/DD'), MoveFromUTCToLocal(moment(p.plannedCheckIn), this.TZ)).format('YYYY/MM/DD');
                            setTimeout(() => { $("#startdate input").val(moment.max(moment($scope.data.selecteddate, 'YYYY/MM/DD'), MoveFromUTCToLocal(moment(p.plannedCheckIn), this.TZ)).format('YYYY/MM/DD')) }, 100);
                            this.max = moment.utc(p.lastValidTime);
                            $scope.data.carrier = p.vector ? p.vector.sapCode : '';
                            $scope.atleastOne = true;
                            if (p.items)
                                $scope.products = p.items;
                            $scope.data.email = p.email;
                            $scope.checkEmail(p.email);
                            $scope.showAutocompleteBtn = false;
                            if (p.firstValidTime && p.freezingHours) {
                                const max = moment.max(this.now().clone().add(p.freezingHours, 'h'), moment.tz(p.firstValidTime, this.TZ));
                                $scope.freezeBooking = Math.ceil(max.diff(this.now(), 'm') / 60);
                                this.findTimeAfterFreeze($scope.loc.Id);
                                $scope.$evalAsync();
                            }
                            //Iniettato solo freezing hours
                            else if (p.freezingHours && !p.firstValidTime) {
                                $scope.freezeBooking = p.freezingHours;
                                this.findTimeAfterFreeze($scope.loc.Id);
                                $scope.$evalAsync();
                            }
                            //Iniettato solo min date
                            else if (!p.freezingHours && p.firstValidTime) {
                                $scope.freezeBooking = moment.tz(p.firstValidTime, this.TZ).diff(this.now(), 'h');
                                this.findTimeAfterFreeze($scope.loc.Id);
                                $scope.$evalAsync();
                            }
                        } catch (exception) {
                            console.error("Exception: ", exception);
                            console.error("Event data:", event.data);
                        } finally {
                            loader.close();
                        }
                    }, 2000);
                }
            }, false);

            $scope.next = function (plantCode: string) {
                WizardHandler.wizard().next();
                $scope.plantCode = plantCode;
            };
            $scope.$watch((a: IBookScope) => a.data.selecteddate, (newValue?: string) => { //YYYY/MM/DD
                const plant = $scope.loc;
                const now = moment.tz(this.TZ);
                const parsed = moment.tz(newValue, "YYYY/MM/DD", this.TZ);
                let selected = newValue ? parsed : now;
                if (selected.isSame(now, 'day'))
                    selected = now.clone().startOf('day');

                if ($scope.minValidDate.isSame(parsed, 'date'))
                    this.findTimeAfterFreeze(plant.Id)
                else {
                    if (plant && !$scope.selectedWD)
                        $http.get<LM.IGetWorkingTime>(`/Book/GetWorkingTime?plantId=${plant.Id}&date=${selected.toISOString()}`).then(res => {
                            if (moment.tz(res.data.openingHour, this.TZ) > now.clone().add(this.$scope.freezeBooking, 'h')) {
                                this.$scope.selectedWD.Opening = (moment.tz(res.data.openingHour, this.TZ)).tz(this.TZ).clone();
                                this.$scope.selectedWD.Closing = moment.tz(res.data.closingHour, this.TZ);
                                this.$scope.data.selectedtime = (moment.tz(res.data.openingHour, this.TZ)).tz(this.TZ).clone().hours();
                            }
                            else {
                                this.$scope.selectedWD.Opening = now.clone().add(this.$scope.freezeBooking, 'h');
                                this.$scope.selectedWD.Closing = moment.tz(res.data.closingHour, this.TZ);
                                this.$scope.data.selectedtime = now.clone().add(this.$scope.freezeBooking, 'h').hours();
                            }

                            $scope.$evalAsync();
                            $scope.docksLimit = res.data.maxDocks;
                        });
                    else if (newValue)

                        $http.get<LM.IGetWorkingTime>(`/Book/GetWorkingTime?plantId=${plant.Id}&date=${selected.toISOString()}`).then(res => {

                            if (moment.tz(res.data.openingHour, this.TZ) > now.clone().add(this.$scope.freezeBooking, 'h')) {
                                this.$scope.selectedWD.Opening = (moment.tz(res.data.openingHour, this.TZ)).tz(this.TZ).clone();
                                this.$scope.selectedWD.Closing = moment.tz(res.data.closingHour, this.TZ);
                                this.$scope.data.selectedtime = (moment.tz(res.data.openingHour, this.TZ)).tz(this.TZ).clone().hours();
                            }
                            else {
                                this.$scope.selectedWD.Opening = now.clone().add(this.$scope.freezeBooking, 'h');
                                this.$scope.selectedWD.Closing = moment.tz(res.data.closingHour, this.TZ);
                                this.$scope.data.selectedtime = now.clone().add(this.$scope.freezeBooking, 'h').hours();
                            }
                            $scope.$evalAsync();
                            $scope.docksLimit = res.data.maxDocks;
                        });
                }
            });

            $scope.navigation_wizard_enabled = function () {
                return WizardHandler.wizard().currentStep().wzTitle !== 'End';
            };


            /**
             * Fix per rimozione UNDEFINED injectata in alcuni campi
             * */
            $scope.removeUndefined = function () {
                $scope.data.refname = $scope.data.refname?.replace('undefined', '');
                $scope.data.refnum = $scope.data.refnum?.replace('undefined', '');
                $scope.data.external = $scope.data.external?.replace('undefined', '');
                $scope.data.sender = $scope.data.sender?.replace('undefined', '');
                $scope.data.receiver = $scope.data.receiver?.replace('undefined', '');
                $scope.data.notes = $scope.data.notes?.replace('undefined', '');
                $scope.data.truckplate = $scope.data.truckplate?.replace('undefined', '');
                $scope.data.trailerplate = $scope.data.trailerplate?.replace('undefined', '');
                $scope.data.carrier = $scope.data.carrier?.replace('undefined', '');
            }
            //const unregister = $scope.$watch((a: IBookScope) => a.data.selecteddate, (newValue?: string) => { //YYYY/MM/DD
            //    const plant = $scope.loc;
            //    const now = moment.tz(this.TZ);
            //    const parsed = moment.tz(newValue, "YYYY/MM/DD", this.TZ);
            //    let selected = newValue ? parsed : now;
            //    if (selected.isSame(now, 'day'))
            //        selected = now.startOf('day');
            //    if (plant && !$scope.selectedWD)
            //        $http.get<LM.IGetWorkingTime>(`/Book/GetWorkingTime?plantId=${plant.Id}&date=${selected.toISOString()}`).then(res => {
            //            $scope.selectedWD.Opening = moment.tz(res.data.openingHour, this.TZ);
            //            $scope.selectedWD.Closing = moment.tz(res.data.closingHour, this.TZ);
            //            $scope.$evalAsync();
            //            $scope.docksLimit = res.data.maxDocks;

            //        });
            //    else if (newValue)
            //        //if (!$scope.selectedWD.Opening.isSame(parsed, 'date') && !$scope.minValidDate.isSame(parsed, 'date'))
            //        $http.get<LM.IGetWorkingTime>(`/Book/GetWorkingTime?plantId=${plant.Id}&date=${selected.toISOString()}`).then(res => {
            //            $scope.selectedWD.Opening = moment.tz(res.data.openingHour, this.TZ);
            //            $scope.selectedWD.Closing = moment.tz(res.data.closingHour, this.TZ);
            //            $scope.$evalAsync();
            //            $scope.docksLimit = res.data.maxDocks;
            //        });
            //    else if ($scope.minValidDate && $scope.minValidDate.isSame(parsed, 'date'))
            //        this.findTimeAfterFreeze(plant.Id);
            //});

        }

        protected selectLapse(lapse: ILapseAvailable) {
            this.$scope.showDanger = !this.$scope.bloppo(lapse.From);
            return super.selectLapse(lapse);
        }
    }

    globalApp.requires.push('mgo-angular-wizard', 'ngSanitize', 'ui.select', 'vcRecaptcha', 'ui.bootstrap', 'angularFileUpload', 'ngMessages', 'ngfallbackSrc');
    globalApp.controller('BookByPlantController', [
        '$scope',
        '$http',
        'WizardHandler',
        '$uibModal',
        'FileUploader',
        'genericHelper',
        '$window',
        '$timeout',
        BookByPlantController,
    ]);
}